import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseQueryResult } from '@tanstack/react-query'
import { usePortalQuery } from 'src/Libs/api'
import { Client } from '../models'
import { getClient } from '../api/client.api'

export const clientQueryKey = (userId: number | undefined) => ['client', userId] as const

/**
 * Fetches the API access client belonging to a user.
 */
export const useClient = (userId: number | undefined): UseQueryResult<Client | null, Error> => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalQuery({
    queryKey: clientQueryKey(userId),
    queryFn: () => getClient(userId, authFetch),
    enabled: !!userId,
  })
}
